/* ══════════════════════════════════════════════════════════
   Flux Labs — quick view for catalog product cards.
   Promotes the clicked .product-card itself to a fixed overlay
   (class .qv-open) and reveals its hidden .card-detail block.
   NO DOM reparenting: the card's variant pills, calcDual closures
   and the add-to-cart button keep working untouched. A same-size
   placeholder holds the card's grid slot while it is open.
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var backdrop = null, openCard = null, placeholder = null;

  function ensureBackdrop() {
    if (backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'qv-backdrop';
    backdrop.addEventListener('click', close);
    document.body.appendChild(backdrop);
    return backdrop;
  }

  function close() {
    if (!openCard) return;
    openCard.classList.remove('qv-open');
    var x = openCard.querySelector('.qv-close');
    if (x) x.remove();
    /* return the card to its exact grid slot (listeners/closures ride along) */
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(openCard, placeholder);
      placeholder.remove();
    }
    placeholder = null;
    if (backdrop) backdrop.classList.remove('show');
    document.body.style.overflow = '';
    openCard = null;
  }

  window.fluxQuickView = function (card) {
    if (openCard === card) return;
    close();
    ensureBackdrop();
    /* hold the grid slot, then lift the card to <body> so no ancestor
       stacking context (section z-index / reveal transforms) can trap it
       under the backdrop. Closures reference the card node itself, so its
       variant/price/cart wiring is unaffected by the move. */
    placeholder = document.createElement('div');
    placeholder.className = 'qv-placeholder';
    placeholder.style.height = card.offsetHeight + 'px';
    card.parentNode.insertBefore(placeholder, card);
    document.body.appendChild(card);

    var x = document.createElement('button');
    x.className = 'qv-close';
    x.setAttribute('aria-label', 'Close quick view');
    x.innerHTML = '✕';
    x.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    card.appendChild(x);

    card.classList.add('qv-open');
    backdrop.classList.add('show');
    document.body.style.overflow = 'hidden';
    openCard = card;
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
